import { useSession } from 'next-auth/react'
import { api } from './instance'

export function makePrivateRequest(callback: (...params: any) => Promise<any>) {
	const { data } = useSession()

	return async (...params: any) => {
		if (!data) return

		api.interceptors.request.use((config) => {
			config.headers.Authorization = `Bearer ${data.access}`
			return config
		})

		const result = await callback(...params)

		api.interceptors.request.clear()

		return result
	}
}
